import { render, staticRenderFns } from "./user_detail.vue?vue&type=template&id=9431f242&scoped=true&"
import script from "./user_detail.vue?vue&type=script&lang=js&"
export * from "./user_detail.vue?vue&type=script&lang=js&"
import style0 from "./user_detail.vue?vue&type=style&index=0&id=9431f242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9431f242",
  null
  
)

export default component.exports